import axiosInstanceSession from "@/utils/axiosInstanceSession";
import rights from "@/store/modules/rights";
import store from "@/store";
import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/oauth`;

const state = {
  accessToken: null,
  permissions: [],
  companyId: null,
};

const getters = {
  getAccessToken: (state) => state.accessToken,
  getCompanyId: (state) => state.companyId,
  isTokenCompany: (state) => (companyId: string | undefined) => {
    return companyId ? state.companyId === companyId : false;
  },
  hasPermission: (state) => (right: string | null) => {
    return right ? state.permissions.includes(right) : state.permissions.length;
  },
};

const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
  },
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
  setCompanyId(state, companyId) {
    state.companyId = companyId;
  },
  reset(state) {
    state.accessToken = null;
    state.permissions =  [];
    state.companyId = null;
  },
};

const actions = {
  async tokenBySession({ commit }, { companyId }: { companyId: number }) {
    try {
      const response = await axiosInstanceSession.post(`${baseUrl}/token-by-session`, { companyId })
        .then((response) => response.data);
      const { accessToken, permissions } = response;
      commit("setAccessToken", accessToken);
      commit("setPermissions", permissions);
      commit("setCompanyId", companyId);
      return accessToken;
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error("Failed to fetch token:", error);
      throw error;
    }
  },
  async adminTokenBySession({ commit }) {
    try {
      const response = await axiosInstanceSession.post(`${baseUrl}/admin-token-by-session`)
        .then((response) => response.data);
      const { accessToken } = response;
      commit("setAccessToken", accessToken);
      return accessToken;
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error("Failed to fetch token:", error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
